









import Vue from 'vue';

interface ProfileTab {
    icon: [string, string];
    label: string;
    href: string;
}

export default Vue.extend({
    name: 'ProfileTabs',
    data() {
        return {};
    },
    computed: {
        tabs(): ProfileTab[] {
            const t = (id: string) => this.$t(`profile.tabs.${id}`).toString();

            return [
                {
                    icon: ['fal', 'user-vneck'],
                    label: t('profile'),
                    href: this.$URLS.profile,
                },
                {
                    icon: ['fal', 'files'],
                    label: t('documents'),
                    href: this.$URLS.profileDocuments,
                },
            ];
        },
    },
});
